import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import StringConstants from 'app/shared/constants/StringConstants';

export default (paths) => {
    const allowParamsRegex = StringConstants.ALLOW_PARAMS_REGEX;
    const transformLegacyAdId = adId => `RT${adId}_Postlets`;

    /*
     * NOTE: react route render props are undefined when hitting the route directly
     * renderProps.component is undefined server side in authenticate.js
     * bypassing getUser to set the user model
     *
     * Wrapping redirect component within a function fixes the issue.
     * https://github.com/ReactTraining/react-router/issues/4942
     */
    const legacyRedirectRouteList = {
        listingPageMissingId: {
            // legacy path broken link coming from Z that's missing id: /rental-manager/listing//*
            path: `${paths.legacyZRM.editListing}(/*)?${allowParamsRegex}`,
            getRedirectRoute: () => <Route render={() => <Redirect to={paths.propertiesPage} />} />,
        },
        howItWorksLandingPage: {
            // legacy path: /rental-manager/how-it-works
            path: `${paths.legacyZRM.howItWorksLandingPage}${allowParamsRegex}`,
            getRedirectRoute: () => <Route render={() => <Redirect to={paths.base} />} />,
        },
        editListing: {
            // legacy path: /rental-manager/listing/12345678/*
            path: `${paths.legacyZRM.editListing}/:propertyId(\\d+)${allowParamsRegex}`,
            // if payments or applications enabled, redirect to /properties/:propertyId/edit
            getPDPRedirectRoute: () => (
                <Route
                    render={props => (
                        <Redirect
                            // eslint-disable-next-line max-len
                            to={`${paths.propertiesPage}/${transformLegacyAdId(props.match.params.propertyId)}/listing`}
                        />
                    )}
                />
            ),
        },
        myListings: {
            // legacy path: /rental-manager/posts/*
            path: `${paths.legacyZRM.myListings}/(.*)?`,
            getRedirectRoute: () => <Route render={() => <Redirect to={paths.propertiesPage} />} />,
        },
    };

    return (
        <Switch>
            <Route path={legacyRedirectRouteList.editListing.path}>
                {legacyRedirectRouteList.editListing.getPDPRedirectRoute()}
            </Route>

            <Route path={legacyRedirectRouteList.myListings.path}>
                {legacyRedirectRouteList.myListings.getRedirectRoute()}
            </Route>

            <Route path={legacyRedirectRouteList.listingPageMissingId.path}>
                {legacyRedirectRouteList.listingPageMissingId.getRedirectRoute()}
            </Route>

            <Route path={legacyRedirectRouteList.howItWorksLandingPage.path}>
                {legacyRedirectRouteList.howItWorksLandingPage.getRedirectRoute()}
            </Route>
        </Switch>
    );
};
